import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivityFeedsService } from 'app/pages/activity-feeds/shared/activity-feeds.service';

@Component({
  selector: 'bulk-delete-dialog',
  templateUrl: './bulk-delete-dialog.component.html',
  styleUrls: ['./bulk-delete-dialog.component.scss']
})
export class BulkDeleteDialogComponent implements OnInit {

  fromDate :any;
  tillDate :any;
  asset_types = [];
  assets = [];
  audit_value :any;
  site_ids : []= [];
  reasons = ['Low Light','Bad Image','Wrong Algorithm','Out of Range'];
  audit_type = ['manual','auto audit'];
  selectedAuditType = '';
  selectedAssetIDsForFilter  = [];
  selectAssestsCount = 0;
  confirm :boolean = false;
  confirmForDuplicatesDelete :boolean  = false;
  bulkFunctionalityIsShown :boolean = false;
  duplicateDeleteIsShown :boolean = false;
  deletedAuditsIsShown :boolean = false;
  falseAuditsIsShown :boolean = false;

  constructor(public activityFeedsService :ActivityFeedsService,
    public dialogRef: MatDialogRef<BulkDeleteDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.audit_value = '';
    this.fromDate = undefined ;
    this.tillDate = undefined;
    this.selectedAssetIDsForFilter = [];
    this.loadAssets();
    let site_id : any = localStorage.getItem("selectedSite");
    if(site_id != '' && site_id != null && site_id != undefined && site_id != "null"){
      this.site_ids = site_id.split(","); 
    }
    this.bulkFunctionalityIsShown = data === 'bulk' ? true : false;
    this.duplicateDeleteIsShown = data === 'duplicate' ? true : false;
    this.deletedAuditsIsShown = data === 'delete' ? true : false;
    this.falseAuditsIsShown = data === 'false audits' ? true : false;
   }

  ngOnInit(): void {
  }

  loadAssets() {
    this.activityFeedsService.getAssets().subscribe(
      (data) => {
        this.asset_types = data.asset_types;
        this.asset_types.forEach((asset_type  :any) => {
          asset_type.assets.forEach((asset : any) => {
            asset.asset_type_id = asset_type.type_id
          })
          asset_type.selected_asset_count = 0;
        })
        
        let assets = [];
        data.asset_types.forEach((asset_type: any) => {
          let assetsObj = asset_type.assets.map((asset) => {
            return { ...asset, asset_type_id: asset_type.type_id };
          });
          assets = [...assets, ...assetsObj];
        });
        this.assets = assets.map((d) => {
          return {
            id: d.asset_id,
            name: d.asset_name,
            asset_type_id: d.asset_type_id,
            checked : false
          };
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  formatAssetName(name) {
    return name.replace(/_/gi, " ");
  }

  applyFilter(){
    if(this.submitBtnEnable() && this.confirm){
      localStorage.setItem("selectedAssetIDsForFilter",JSON.stringify(this.selectedAssetIDsForFilter));
      
      this.dialogRef.close();
      let deleteDetails: any = {
        dbName: '',
        asset_id: [],
        site_id: [],
        fromDate: '',
        toDate: '',
        user_id: '',
        audit_value: '',
        isBulkDelete : ''
    };
    
    let currentUserString = localStorage.getItem("currentUser");
    let currentUser: any = currentUserString ? JSON.parse(currentUserString) : null;
    
    if (currentUser) {
        deleteDetails.dbName = currentUser.db_name || '';
        deleteDetails.user_id = currentUser.user_id || '';
    }
      deleteDetails.asset_id = this.selectedAssetIDsForFilter;
      deleteDetails.site_id = this.site_ids;
      deleteDetails.audit_value = this.audit_value;
      deleteDetails.fromDate = this.fromDate;
      deleteDetails.toDate = this.tillDate;
      deleteDetails.isBulkDelete = true;
      deleteDetails.audit_type = this.selectedAuditType;
      /**make API call */
       this.activityFeedsService.bulkDelete(deleteDetails).subscribe(
            (res: any) => {
              alert(res.message);
            },
            (error) => {
              alert(error);
            }
          );
    }
  }

  closeBox(){
    this.dialogRef.close();
  }

  falseAuditCloseBox(){
    if(this.falseAuditsIsShown){
      localStorage.setItem("selectedAssetIDsFalseAudits",JSON.stringify(this.selectedAssetIDsForFilter));
      localStorage.setItem("fromDateFalseAudits",this.fromDate);
      localStorage.setItem("tillDateFalseAudits",this.tillDate);
      let data : any = {};
      data.fromDate = this.fromDate;
      data.tillDate = this.tillDate;  
      data.selectedAssetIDsForFilter = this.selectedAssetIDsForFilter;
      this.dialogRef.close(data);
    }
    else{
      this.dialogRef.close();
    }
  }

  filterAssetSelected(asset :any){
    if(asset.checked){
      let index = this.selectedAssetIDsForFilter.findIndex((id:any) =>  
        {
            return id === asset.id
        });
        if(index < 0){
          this.selectedAssetIDsForFilter.push(asset.id);
          this.asset_types.forEach((assetype : any) =>{
            if(asset.asset_type_id === assetype.type_id){
              assetype.selected_asset_count += 1;
            }
          })
        }
    }
    else{
      this.selectedAssetIDsForFilter = this.selectedAssetIDsForFilter.filter((id:any) => id != asset.id);
      this.asset_types.forEach((assetype : any) =>{
        if(asset.asset_type_id === assetype.type_id){
          assetype.selected_asset_count -= 1;
        }
      })
    }
  }

  onAssetTypeSelected(asset_type :any){
    if(asset_type.checked){
      asset_type.assets.forEach((asset : any) => {
        let index = this.selectedAssetIDsForFilter.findIndex((id:any) =>  
        {
            return id === asset.asset_id
        });
        if(index < 0){
          this.selectedAssetIDsForFilter.push(asset.asset_id);
          this.asset_types.forEach((assetype : any) =>{
            if(asset.asset_type_id === assetype.type_id){
              assetype.selected_asset_count += 1;
            }
          })
        }
      })
    }
    else{
      asset_type.assets.forEach((asset : any) => {
        let index = this.selectedAssetIDsForFilter.findIndex((id:any) =>  
        {
            return id === asset.asset_id
        });
        if(index >= 0){
          this.selectedAssetIDsForFilter = this.selectedAssetIDsForFilter.filter((id:any) => id != asset.asset_id);
          this.asset_types.forEach((assetype : any) =>{
            if(asset.asset_type_id === assetype.type_id){
              assetype.selected_asset_count -= 1;
            }
          })
        }
      })
    }
  }

  checkAssetSelected(asset: any){
    let index = this.selectedAssetIDsForFilter.findIndex((id:any) =>  
      {
          return id === asset.id
      });
    return index > -1 ? true : false;
  }

  selectAllAsset(event  :any){
    if(event.target.checked){
      this.asset_types.forEach((asset_type : any) => {
        asset_type.assets.forEach((asset : any) => {
          let index = this.selectedAssetIDsForFilter.findIndex((id:any) =>  
            {
                return id === asset.asset_id
            });
            if(index < 0){
              this.selectedAssetIDsForFilter.push(asset.asset_id);
              this.asset_types.forEach((assetype : any) =>{
                if(asset.asset_type_id === assetype.type_id){
                  assetype.selected_asset_count += 1;
                }
              })
            }
        })
      })
    }
    else{
      this.selectedAssetIDsForFilter = [];
      this.asset_types.forEach((assetype : any) =>{
        assetype.selected_asset_count = 0;
      })
    }
  }

  submitBtnEnable(){
    this.selectAssestsCount = 0;
    if(this.fromDate != undefined && this.tillDate != undefined && this.selectedAssetIDsForFilter?.length > 0 && this.audit_value != '' && this.selectedAuditType != ''){
      this.asset_types.forEach((assetype : any) =>{
        this.selectAssestsCount += assetype.selected_asset_count;
      })
      return true;
    }
    else{
      return false;
    }
  }

  reasonSelected(res : any) {
    this.audit_value = res;
  }

  confirmClick(){
    this.confirm = !this.confirm;
  }

  deleteBtnEnable(){
    if(this.fromDate != undefined && this.tillDate != undefined ){
      return true;
    }
    else{
      return false;
    }
  }

  confirmClickForDuplicatesDelete(){
    this.confirmForDuplicatesDelete = !this.confirmForDuplicatesDelete;
  }

  /**same API is used to both bulk/duplicate delete */
  deleteDuplicates(){
    if(this.deleteBtnEnable() && this.confirmForDuplicatesDelete){
      this.dialogRef.close();
      let deleteDetails: any = {
        dbName: '',
        site_id: [],
        fromDate: '',
        toDate: '',
        user_id: '',
        isBulkDelete : ''
    };
    let currentUserString = localStorage.getItem("currentUser");
    let currentUser: any = currentUserString ? JSON.parse(currentUserString) : null;
    if (currentUser) {
        deleteDetails.dbName = currentUser.db_name || '';
        deleteDetails.user_id = currentUser.user_id || '';
    }
      deleteDetails.site_id = this.site_ids;
      deleteDetails.fromDate = this.fromDate;
      deleteDetails.toDate = this.tillDate;
      deleteDetails.isBulkDelete = false;
      /**make API call */
       this.activityFeedsService.bulkDelete(deleteDetails).subscribe(
            (res: any) => {
              alert(res.message);
            },
            (error) => {
              alert(error);
            }
          );
    }
  }

  displayDeletedData(){
    let deleteDetails: any = {
      dbName: '',
      site_id: [],
      fromDate: '',
      tillDate: '',
      assets: []
  };

  let currentUserString = localStorage.getItem("currentUser");
    let currentUser: any = currentUserString ? JSON.parse(currentUserString) : null;
    if (currentUser) {
        deleteDetails.dbName = currentUser.db_name || '';
    }
      deleteDetails.site_id = this.site_ids;
      deleteDetails.fromDate = this.fromDate;
      deleteDetails.tillDate = this.tillDate;
      deleteDetails.selectedAssetIDsForFilter = this.selectedAssetIDsForFilter;
      deleteDetails.assets = [];
      
      localStorage.setItem("fromDateDeletedAudits",this.fromDate);
      localStorage.setItem("tillDateDeletedAudits",this.tillDate);
      localStorage.setItem("selectedAssetIDsForFilter", deleteDetails.selectedAssetIDsForFilter);

    this.dialogRef.close(deleteDetails);
  }

  auditTypeSelected(audit_value : any){
    this.selectedAuditType = audit_value;
  }

}
